import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const WidgetAction = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${color.light};
`;

const LinkSubscribeWrapper = styled.div`
  width: 100%;
  margin-top: 10px;
`;

const ButtonSubscribe = styled(Button)`
  width: ${(props) => props.width || '80%'};
  margin: 0 auto;
`;

const NotProWrapper = styled.div`
  height: 330px;
`;

export { WidgetAction, LinkSubscribeWrapper, ButtonSubscribe, NotProWrapper };
